import React, { FC } from "react"
import { Table } from "@/components"
import { Quote } from "@/lib/types"
import { convertEquipmentType, dateFormat1, time } from "@/lib/services"

type Props = {
  listingData: { errorRecord: Quote[] }
  header: {
    name: string
    width: string
  }[]
}

const formatCityState = (location?: { city?: string; state?: string }) => {
  if (!location) return ""

  const city = location.city?.trim()
  const state = location.state?.trim()

  if (city && state) return `${city}, ${state}`
  return city || state || ""
}

const joinUnique = (values: (string | undefined)[]) => {
  const uniqueValues = Array.from(
    new Set(values.map((value) => value?.trim()).filter(Boolean)),
  )

  return uniqueValues.length > 0 ? uniqueValues.join(" / ") : "-"
}

const getMarket = (
  location?: {
    marketName?: string
    market?: string
    marketNames?: string[]
  },
  fallbackMarket?: string,
) => {
  if (fallbackMarket?.trim()) return fallbackMarket.trim()
  if (location?.marketName?.trim()) return location.marketName.trim()
  if (location?.market?.trim()) return location.market.trim()

  return location?.marketNames?.find((market) => market.trim())?.trim()
}

const getCityState = (quote: Quote) => {
  return (
    quote.cityState ||
    joinUnique([
      quote.originCityState ||
        quote.origin ||
        formatCityState(quote.payload?.originLatLng),
      quote.destinationCityState ||
        quote.destination ||
        formatCityState(quote.payload?.destinationLatLng),
    ])
  )
}

const getMarketLabel = (quote: Quote) => {
  return (
    quote.market ||
    joinUnique([
      quote.originMarket ||
        getMarket(quote.payload?.originLatLng, quote.payload?.originMarket),
      quote.destinationMarket ||
        getMarket(
          quote.payload?.destinationLatLng,
          quote.payload?.destinationMarket,
        ),
    ])
  )
}

export const QuoteErrors: FC<Props> = (props) => {
  return (
    <div className="m-4">
      <Table
        header={props.header}
        headerAlign="text-left"
        lastheadingAlign="text-right"
        tableClassName="min-w-[2260px]"
      >
        {props.listingData.errorRecord.map((e, i) => (
          <tr key={i} className="text-left">
            <td className={"whitespace-nowrap p-4 w-40 shrink-0"}>
              {convertEquipmentType(e.equipmentType)}
            </td>
            <td className={"whitespace-nowrap p-4 w-36 shrink-0"}>
              {e.originZip}
            </td>
            <td className={"whitespace-nowrap p-4 w-40 shrink-0"}>
              {e.destinationZip}
            </td>
            <td className={"whitespace-nowrap p-4 w-72 shrink-0"}>
              {getCityState(e)}
            </td>
            <td className={"whitespace-nowrap p-4 w-72 shrink-0"}>
              {getMarketLabel(e)}
            </td>
            <td className={"whitespace-nowrap p-4 w-40 shrink-0"}>
              <p>{dateFormat1(e.pickUpDate)}</p>
            </td>
            <td className="p-4 w-96 shrink-0 overflow-auto scrollbar-hidden">
              {e.message}
            </td>
            <td className="py-4 ml-4 w-56 shrink-0 overflow-auto scrollbar-hidden text-center">
              {e.user?.email ? e.user.email : "-"}
            </td>
            <td className={"whitespace-nowrap p-4 text-right w-48 shrink-0"}>
              <p>
                {dateFormat1(e.createdAt as string)}{" "}
                {time(e.createdAt as string)}
              </p>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  )
}
